import { Checkbox } from '@web/components/atoms/Checkbox'
import { HStack } from '@web/components/atoms/Layout'
import { ReactNode } from 'react'

type PageCheckBoxProps = {
  id: string
  isChecked: boolean
  onChange: (value: boolean) => void
  label: string | ReactNode
  name?: string
  required?: boolean
}

const PageCheckBox = ({ id, name, onChange, label, isChecked, required }: PageCheckBoxProps) => {
  return (
    <HStack onClick={() => onChange(!isChecked)} cursor="pointer">
      <Checkbox
        id={id}
        name={name}
        checked={isChecked}
        required={required}
        alignItems="start"
        css={{
          '&': {
            pointerEvents: 'none',
            '--chakra-colors-color-palette-solid': 'var(--branding-button-primary-bg-color)',
            '--chakra-colors-border': 'ge.input.outline',
          },
          '& .chakra-checkbox__control': {
            borderColor: 'ge.input.outline',
            borderWidth: '2px',
          },
          '& .chakra-checkbox__control[data-checked]': {
            bgColor: 'var(--branding-button-primary-bg-color)',
            borderColor: 'var(--branding-button-primary-bg-color)',
          },
          '& .chakra-checkbox__label': {
            whiteSpace: 'pre-line',
          },
        }}
      >
        {label}
      </Checkbox>
    </HStack>
  )
}

export default PageCheckBox
